import CheckDarkIcon from "@/User/Assets/Svgs/CheckDarkIcon.svg";
import React from "react";
import { components } from "react-select";

export const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0.499512L5 5.49951L10 0.499512H0Z" fill="#1F2C37" />
            </svg>
        </components.DropdownIndicator>
    );
};

export const buildInput = (inputClasses) => {
    return (props) => (
        <components.Input {...props} inputClassName={inputClasses} />
    );
};

export const Option = (props) => {
    const { children, innerProps, isSelected } = props;

    return (
        <div className="flex justify-between items-center p-2.5 hover:bg-silk-blue/[.08] cursor-pointer" {...innerProps }>
            <span className="text-sm leading-normal text-midnight">{children}</span>
            {isSelected && <img className="w-6 h-6" src={CheckDarkIcon} />}
        </div>
    );
};
